import { Range } from "@pdfking/tfunc"

/**
 * Creates array of numbers in range.
 *
 * @param n1 - Start (or end if n2 omitted)
 * @param n2 - End (inclusive, optional)
 * @param step - Step size (default: 1)
 * @returns Array of numbers
 *
 * @example
 * ```ts
 * import { range } from "@pdfking/rfunc"
 *
 * range(5) // [0, 1, 2, 3, 4]
 * range(1, 5) // [1, 2, 3, 4, 5]
 * range(0, 4, 2) // [0, 2, 4]
 * ```
 */
export const range = (n1: number, n2?: number, step = 1) => [
  ...Range(n1, n2, step),
]
